<form class="mx-6" [formGroup]="form">
  <section class="flex flex-wrap flex-row">
    <div class="flex flex-col w-full mb-3">
      <h1>Additional Insured Request</h1>
      <div class="mt-2 mb-6">
        <lib-button [cssType]="'btn-link'" [text]="backToText()" [icon]="'circleleft'" [buttonType]="'button'"
          (click)="goBack()"></lib-button>
      </div>
    </div>
    <h2 class="app w-full mb-2">{{form.get('companyName')?.value}} - {{form.get('policyNumber')?.value}}</h2>
    <!-- TODO this verbage is from a different page, update -->
    <p class="mb-4">Please make any updates to the location, contact and operations information. If no changes, proceed
      to Quote Info.</p>
    <div *ngIf="data?.policyChangeStatus === 'Issued'" class="w-full font-bold border-2 border-gray-300 p-3 mb-3">
      <h3 class="app font-bold mb-2">Endorsement Issued</h3>
      <div class="flex items-start gap-3">
        <p class="my-auto">
          An additional insured endorsement has been issued for this policy. Please use the button to download the
          document associated with this notice.
        </p>
        <div class="button-btn-outline">
          <lib-button *ngIf="data?.policyChangeStatus === 'Issued'" (click)="download()" [buttonType]="'button'"
            text="Download Document">
          </lib-button>
        </div>
      </div>
    </div>
    <div *ngIf="data?.policyChangeStatus === 'Declined'" class="w-full font-bold border-2 border-gray-300 p-3 mb-3">
      <h4 class="font-bold mb-2">Endorsement Declined</h4>
      <p class="my-auto">
        This additional insured endorsement has been declined for the above named policy. Should you have any
        questions, please contact the Affiliated underwriting team.
      </p>
    </div>
    <h3 class="app w-full my-4">Request Information</h3>
    <div class="w-full flex">
      <lib-form-dropdown class="w-full" label="Type of Endorsement" [options]="endorsementtypes"
        formControlName="typeOfEndorsement"></lib-form-dropdown>
    </div>
    @if (isLongerForm()) {
    <div class="mb-3 flex flex-col w-full mt-3">
      <div class="flex w-full items-center justify-between">
        <p class="bold">Do you need to add the CG2001- Primary Wording Endorsement?</p>
        <mat-radio-group aria-label="Select an option" class="radio-buttons-size items-center" formControlName="cG2001">
          <mat-radio-button [value]="true">Yes</mat-radio-button>
          <mat-radio-button [value]="false">No</mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="flex w-full items-center justify-between">
        <p class="bold">Do you need to add the CG2404 - Waiver Wording Endorsement?</p>
        <mat-radio-group aria-label="Select an option" class="radio-buttons-size  items-center"
          formControlName="cG2404">
          <mat-radio-button [value]="true">Yes</mat-radio-button>
          <mat-radio-button [value]="false">No</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
    <h3 class="app my-4">Additional Insured Information</h3>
    <div class="w-full gap-[35px]">
      <lib-form-text class="w-full" label="Name of Additional Insured Person(s) or Organization(s)"
        formControlName="additionalInsuredName"></lib-form-text>
      <ng-container formGroupName="location">
        <div class="w-full flex gap-[35px]">
          <lib-form-text class="w-1/2" label="Street Address" formControlName="streetAddress"></lib-form-text>
          <lib-form-text class="w-1/2" label="Suite" formControlName="aptSuiteBuilding"></lib-form-text>
        </div>
        <div class="w-full flex gap-[35px]">
          <lib-form-text class="w-1/2" label="City" formControlName="city"></lib-form-text>
          <div class="flex w-1/2 gap-[35px]">
            <lib-form-dropdown class="w-1/2" label="State" [options]="states"
              formControlName="state"></lib-form-dropdown>
            <lib-form-text class="w-1/2" label="Zip Code" formControlName="zipCode" mask="99999"></lib-form-text>
          </div>
        </div>
      </ng-container>
      <div class="w-full my-4">
        <p class="my-6">The above listed Additional Insured party has requested Additional Insured status on the
          above listed policy. To help determine insurable interest and acceptability, please complete the
          following questions.</p>
        <div class="flex w-full items-center justify-between">
          <p class="bold">Does Insured have a written contract with Additional Insured Parties?</p>
          <mat-radio-group aria-label="Select an option" class="radio-buttons-size items-center"
            formControlName="writtenContract">
            <mat-radio-button [value]="true">Yes</mat-radio-button>
            <mat-radio-button [value]="false">No</mat-radio-button>
          </mat-radio-group>
          <mat-error *ngIf="showWrittenContractError()">
            A written contract is a requirement to submit an additional insured request.
          </mat-error>
        </div>
      </div>
      <div class="w-full flex gap-[35px]">
        <lib-form-dropdown class="w-1/2" label="What is the insurable interest of the Additional Insured?"
          [options]="insurableInterest" formControlName="insurableInterest"></lib-form-dropdown>
        <lib-form-text class="w-1/2" label="What are the operations of the requested additional insured?"
          formControlName="operations"></lib-form-text>
      </div>
      <div class="flex w-full items-center justify-between">
        <p class="bold">If more than one person or organization is shown as part of the additional insured being
          requested, do they all have combinable interest? If no, separate additional insured requests are
          required.</p>
        <mat-radio-group aria-label="Select an option" class="radio-buttons-size flex gap-3 items-center"
          formControlName="combinableInterest">
          <mat-radio-button [value]="true">Yes</mat-radio-button>
          <mat-radio-button [value]="false">No</mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="flex w-full items-center justify-between">
        <p class="bold">Does the additional insured maintain their own insurance to cover their operational
          exposures?</p>
        <mat-radio-group aria-label="Select an option" class="radio-buttons-size flex gap-3 items-center"
          formControlName="aiOwnInsurance">
          <mat-radio-button [value]="true">Yes</mat-radio-button>
          <mat-radio-button [value]="false">No</mat-radio-button>
        </mat-radio-group>
        <mat-error *ngIf="showAiOwnInsuranceError()">
          Additional insured is required to maintain own insurance.
        </mat-error>
      </div>
    </div>
    <h3 class="app my-4 w-full">Location Information</h3>
    <div class="flex w-full items-center justify-between">
      <p class="bold">Project address is what type of location?</p>
      <mat-radio-group aria-label="Select an option" class="radio-buttons-size flex gap-3 items-center"
        formControlName="projectAddressType">
        <mat-radio-button value="Commercial"><strong>Commercial</strong></mat-radio-button>
        <mat-radio-button value="Industrial"><strong>Industrial</strong></mat-radio-button>
        <mat-radio-button value="Residential"><strong>Residential</strong></mat-radio-button>
      </mat-radio-group>
    </div>
    <div class="flex w-full items-center justify-between">
      <p class="bold">Is project work completed in one location or various?</p>
      <mat-radio-group aria-label="Select an option" class="radio-buttons-size flex gap-3 items-center"
        formControlName="singleOrVarious">
        <mat-radio-button value="Single Location"><strong>Single Location</strong></mat-radio-button>
        <mat-radio-button value="Various"><strong>Various</strong></mat-radio-button>
      </mat-radio-group>
    </div>
    <ng-container *ngIf="form.get('singleOrVarious')?.value === 'Single Location'; else various"
      formGroupName="projectLocation">
      <div class="w-full flex gap-[35px]">
        <lib-form-text class="w-1/2" label="Street Address" formControlName="streetAddress"></lib-form-text>
        <lib-form-text class="w-1/2" label="Suite" formControlName="aptSuiteBuilding"></lib-form-text>
      </div>
      <div class="w-full flex gap-[35px]">
        <lib-form-text class="w-1/2" label="City" formControlName="city"></lib-form-text>
        <div class="flex w-1/2 gap-[35px]">
          <lib-form-dropdown class="w-1/2" label="State" [options]="states" formControlName="state"></lib-form-dropdown>
          <lib-form-text class="w-1/2" label="Zip Code" formControlName="zipCode" mask="99999"></lib-form-text>
        </div>
      </div>
    </ng-container>
    <ng-template #various>
      <lib-form-text-area class="w-full" label="Describe the various locations to be included." [rows]="5"
        formControlName="projectLocationVarious" [maxlength]="500"></lib-form-text-area>
    </ng-template>
    <h3 class="app my-4">Project Information</h3>
    <div class="w-full flex gap-[35px]">
      <lib-form-dropdown class="w-1/4" label="Project Type" [options]="projecttypes"
        formControlName="projectType"></lib-form-dropdown>
      <lib-form-money class="w-1/4" label="Estimated Gross Receipts paid to the Name Insured"
        formControlName="estimatedGrossReceipts" mask="0*" [prefix]="'$'"></lib-form-money>
      <lib-custom-date-picker class="w-1/4" label="Estimated Start Date" formControlName="estimatedStartDate"></lib-custom-date-picker>
      <lib-custom-date-picker class="w-1/4" label="Estimated Completion Date"
        formControlName="estimatedCompletionDate"></lib-custom-date-picker>
    </div>
    <lib-form-text-area class="w-full"
      label="Description of Project  (ex. Residential Remodel, or New construction of Restaurant)" [rows]="5"
      formControlName="projectDescription" [maxlength]="500"></lib-form-text-area>
    <h4 class="app mb-2 bold">Complete the following regarding the work to be performed</h4>
    <div *ngIf="form.get('projectAddressType')?.value === 'Residential'" class="w-full flex gap-[35px]">
      <lib-form-dropdown class="w-1/2" label="If Residential, project is what type of dwelling?"
        [options]="dwellingtypes" formControlName="dwellingType"></lib-form-dropdown>
      <lib-form-dropdown class="w-1/2" label="Working for?" [options]="workingForTypes"
        formControlName="workingFor"></lib-form-dropdown>
    </div>
    <div *ngIf="form.get('projectAddressType')?.value === 'Commercial'" class="w-full flex gap-[35px]">
      <lib-form-dropdown class="w-1/2" label="If Commercial, project is what type of dwelling?"
        [options]="commercialTypes" formControlName="dwellingType"></lib-form-dropdown>
    </div>
    <div class="flex w-full items-center justify-between">
      <p class="bold">Is the above project/job work required because of a prior construction defect?</p>
      <mat-radio-group aria-label="Select an option" class="radio-buttons-size flex gap-3 items-center"
        formControlName="priorDefect">
        <mat-radio-button [value]="true">Yes</mat-radio-button>
        <mat-radio-button [value]="false">No</mat-radio-button>
      </mat-radio-group>
      <mat-error *ngIf="form.get('priorDefect')?.touched && form.get('priorDefect')?.errors">
        {{form.get('priorDefect')?.errors}}
      </mat-error>
    </div>
    <div *ngIf="form.get('priorDefect')?.value === true" class="w-full">
      <lib-form-text-area class="w-full" label="If Yes, explain." [rows]="5" formControlName="priorDefectExplanation"
        [maxlength]="500"></lib-form-text-area>
    </div>
    <p class="bold large mb-2 mt-[40px]">Complete the following regarding the work to be performed.</p>
    <div class="w-full flex flex-col gap-3 mb-3 ">
      <div class="flex w-full items-center justify-between">
        <p class="bold">Do you plan to hire subcontractors (subs) to perform any work on this project on your
          behalf?</p>
        <mat-radio-group aria-label="Select an option" class="radio-buttons-size flex gap-3 items-center"
          formControlName="willHireSubcontractors">
          <mat-radio-button [value]="true">Yes</mat-radio-button>
          <mat-radio-button [value]="false">No</mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="flex w-full items-center justify-between">
        <p class="bold">If you hire subs to perform any work on this project, will you utilize a written contract
          that contains a hold harmless clause in your favor?</p>
        <mat-radio-group aria-label="Select an option" class="radio-buttons-size flex gap-3 items-center"
          formControlName="subsWrittenContract">
          <mat-radio-button [value]="true">Yes</mat-radio-button>
          <mat-radio-button [value]="false">No</mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="flex w-full items-center justify-between">
        <p class="bold">If you hire subs to perform any work on this project, will you require your subs to name you
          as Additional Insured on their GL policy?</p>
        <mat-radio-group aria-label="Select an option" class="radio-buttons-size flex gap-3 items-center"
          formControlName="subsAdditionalInsured">
          <mat-radio-button [value]="true">Yes</mat-radio-button>
          <mat-radio-button [value]="false">No</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
    <div class="my-6 applicant-acknowledgements-bg">
      <div class="py-4">
        <h2 class="app pb-4">Applicant Acknowledgements</h2>
        <h3 class="app py-4">Applicant Notice</h3>
        <p>
          By submitting this form, the requester confirms that they are an authorized representative of the
          Named Insured; represents that reasonable enquiry has been made to obtain accurate answers to all
          questions on this application; represents that the answers are true, correct and complete to the best
          of his / her knowledge.
        </p>
        <h3 class="app py-4">Fraud Notice</h3>
        <p>
          Any person who knowingly and with intent attempts to defraud any insurance company, representative, or
          other person; or files an application for insurance or statement of claim, containing any materialy
          false information; or conceals for the purpose of misleading, information concerning any fact material
          thereto is committing a fraudulent insurance act, which is a crime and subjects such person to
          criminal and civil penalties.
        </p>
        <h3 class="app py-4">Premium Notice</h3>
        <p>
          Adding an Additional Insured Endorsement to your policy may incur additional premium, the exact amount
          of which will be determined based on the specifics of the request and the terms of the underlying
          policy. By submitting this request, you acknowledge that the premium for adding an Additional Insured
          Endorsement is subject to change and will be confirmed prior to processing.
        </p>
        <mat-checkbox class="nowrap-text pt-6" color="primary" formControlName="acknowledgement">
          <div>I confirm my understanding of these acknowledgements.</div>
        </mat-checkbox>
        <mat-error class="ml-3 error-list"
          *ngIf="form.get('acknowledgement')?.hasError('required') && form.get('acknowledgement')?.touched">
          Required
        </mat-error>
      </div>
    </div>
    <div *ngIf="roles().includes('admin')" class="w-full flex gap-[35px]">
      <lib-form-money class="w-1/2" label="Additional Premium" formControlName="additionalPremium" mask="0*"
        [prefix]="'$'"></lib-form-money>
    </div>
    <div *ngIf="data?.policyChangeStatus === 'PendingSignature'"
      class="w-full font-bold border-2 border-gray-300 p-3 mb-3">
      <h4 class=" font-bold mb-2">Pending Signature</h4>
      <div class="flex items-start gap-3">
        <p *ngIf="!roles().includes('admin')" class="my-auto">
          This application must be reviewed and signed by the insured. When complete, upload the signed
          application to the documents section. This is required for an Affiliated Underwriter to review your
          additional insured request.
        </p>
        <p *ngIf="roles().includes('admin')" class="my-auto">
          This application must be reviewed and signed by the insured. When complete, the agent will upload the
          signed application to the documents section.
        </p>
        <div class="button-btn-outline">
          <lib-button (click)="downloadApplication()" [buttonType]="'button'" text="Download Application">
          </lib-button>
        </div>
      </div>
    </div>
    } @else {
    <h3 class="app w-full mb-0 mt-[35px]">Additional Insured Information</h3>
    <div class="w-full flex gap-[35px]">
      <lib-form-text class="w-full" label="Name of Additional Insured Person(s) or Organization(s)"
        formControlName="additionalInsuredName"></lib-form-text>
    </div>
    <div class="w-full flex">
      <lib-form-dropdown class="w-1/2" label="What is the Additional Insured's relationship to the Insured"
        [options]="relationship" formControlName="insuredRelationship"></lib-form-dropdown>
    </div>
    <div class="w-full flex mt-3 gap-[35px]">
      <div class="flex w-1/2">
        <p class="bold">Does Insured have a written contract with Additional Insured Parties?</p>
      </div>
       <div class="flex w-1/2 justify-end">
         <mat-radio-group aria-label="Select an option" class="radio-buttons-size items-center"
           formControlName="writtenContract">
           <mat-radio-button [value]="true">Yes</mat-radio-button>
           <mat-radio-button [value]="false">No</mat-radio-button>
         </mat-radio-group>
       </div>
    </div>

    <div *ngIf="otherRelationship" class="w-full">
      <lib-form-text class="w-full" label="Explain Relationship to the Insured"
        formControlName="otherRelationship"></lib-form-text>
    </div>
    <h3 class="app w-full mb-0 mt-[35px]">Project Information</h3>
    <div class="w-full flex flex-shrink">
      <lib-form-dropdown class="w-1/2" label="Project Type" [options]="projecttypes"
        formControlName="projectType"></lib-form-dropdown>
    </div>
    <div class="w-full flex">
      <div class="flex w-1/2">
         <p class="bold">Is this project covered under a WRAP/OCIP policy?</p>
      </div>
      <div class="flex w-1/2 justify-end">
          <mat-radio-group aria-label="Select an option" class="radio-buttons-size items-center"
          formControlName="isWRAPPolicy">
          <mat-radio-button [value]="true">Yes</mat-radio-button>
          <mat-radio-button [value]="false">No</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
    <lib-form-text-area class="w-full"
      label="Description of Project  (ex. Residential Remodel, or New construction of Restaurant)" [rows]="5"
      formControlName="projectDescription" [maxlength]="500"></lib-form-text-area>
    <h3 class="app w-full mb-0 mt-[35px]">Location</h3>
    <ng-container formGroupName="projectLocation">
      <div class="w-full flex gap-[35px]">
        <lib-form-text class="w-1/2" label="Street Address" formControlName="streetAddress"></lib-form-text>
        <lib-form-text class="w-1/2" label="Suite" formControlName="aptSuiteBuilding"></lib-form-text>
      </div>
      <div class="w-full flex gap-[35px]">
        <lib-form-text class="w-4/12" label="City" formControlName="city"></lib-form-text>
        <lib-form-dropdown class="w-4/12" label="State" [options]="states" formControlName="state"></lib-form-dropdown>
        <lib-form-text class="w-4/12" label="Zip Code" formControlName="zipCode" mask="99999"></lib-form-text>
      </div>
    </ng-container>
    <div *ngIf="roles().includes('admin')" class="w-full flex gap-[35px]">
      <lib-form-money class="w-1/2" label="Additional Premium" formControlName="additionalPremium" mask="0*"
        [prefix]="'$'"></lib-form-money>
    </div>

    <div class="w-full mt-[25px]">
      <lib-form-text-area class="w-full" label="Any notes or additional instructions?" [rows]="5"
      formControlName="projectNotes" [maxlength]="500"></lib-form-text-area>
    </div>
    }
  </section>
</form>
<div align="center" *ngIf="mode !== 'view' || roles().includes('admin')">
  <div class="flex flex-col gap-3">
    <ng-container *ngIf="errorList.length > 0">
      <div class="error-list">
        <ul class="list-none">
          <li class="text-red-400" *ngFor="let error of errorList()">{{error}}</li>
        </ul>
      </div>
    </ng-container>
    <ng-container *ngIf="!isApplicationComplete(); else complete">
      <div class="button-submit my-[40px]">
        <lib-button [icon]="'rightarrow'"
          *ngIf="mode !== 'view' && data?.policyChangeStatus !== 'Requested' && data?.policyChangeStatus !== 'PendingSignature'"
          (click)="submitRequest()" [buttonType]="'button'" [cssType]="'btn-primary'"
          [text]="isLongerForm() ? 'Create Application' : 'Submit Request'"
          [disabled]="!form.get('acknowledgement')?.value && isLongerForm()">
        </lib-button>
      </div>
      <div
        *ngIf="roles().includes('admin') && (data?.policyChangeStatus === 'Requested' || data?.policyChangeStatus === 'PendingSignature')"
        class="flex justify-center items-center gap-3">
        <div class="button-submit">
          <lib-button (click)="issuePolicyChange()" [buttonType]="'button'" [cssType]="'btn-primary'"
            text="Issue Endorsement">
          </lib-button>
        </div>
        <div class="button-btn-outline">
          <lib-button (click)="decline()" [buttonType]="'button'" text="Decline">
          </lib-button>
        </div>
      </div>
    </ng-container>
    <ng-template #complete>
      <div class="text-center py-8">
        <p class="bold">{{ selectedFormLabel }}</p>
        <p>The application for your Additional Insured request has been created. Download the application using the
          button below.</p>
        <p>This application must be reviewed and signed by the insured. When complete, upload the signed application
          to the documents section. This is required for an Affiliated Underwriter to review your additional insured
          request.</p>
      </div>
      <lib-button (click)="downloadApplication()" [buttonType]="'button'" [cssType]="'btn-primary'"
        [text]="'Download Application'" [disabled]="policyChangeGuid === '' ? true : false">
      </lib-button>
    </ng-template>
  </div>
</div>